import authService from '@/services/cebeoService/modules/authService';

const state = {};

const mutations = {};

const getters = {};

const actions = {
  getAccessToken: () => {
    return new Promise((resolve, reject) => {
      authService.getAccessToken()
        .then(() => {
          resolve();
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }
};

export default {
  state,
  mutations,
  getters,
  actions,
};
